import { render, staticRenderFns } from "./EditorSocialsPanel.vue?vue&type=template&id=cda9145e&scoped=true"
import script from "./EditorSocialsPanel.vue?vue&type=script&lang=js"
export * from "./EditorSocialsPanel.vue?vue&type=script&lang=js"
import style0 from "./EditorSocialsPanel.vue?vue&type=style&index=0&id=cda9145e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda9145e",
  null
  
)

export default component.exports